import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { AuthenticationStore, UserStore } from '../stores';

export const useAuthenticationStore = () =>
  useContext<{
    authenticationStore: AuthenticationStore;
  }>(StoreContext);
